import classnames from 'classnames';
import PropTypes from 'prop-types';
import './style.scss';
import { jsx as _jsx } from "react/jsx-runtime";

var StoryMainPanelIntro = function StoryMainPanelIntro(_ref) {
  var className = _ref.className,
      children = _ref.children,
      backgroundImage = _ref.backgroundImage,
      theme = _ref.theme;

  var classes = function classes(name) {
    return classnames(name, {}, 'is-' + theme + '-theme', className);
  };

  return /*#__PURE__*/_jsx("div", {
    className: classes('ptr-StoryMainPanelIntro'),
    style: {
      backgroundImage: "url(".concat(backgroundImage, ")")
    },
    children: /*#__PURE__*/_jsx("div", {
      className: classes('ptr-StoryMainPanelIntro-overlay'),
      children: children
    })
  });
};

StoryMainPanelIntro.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  backgroundImage: PropTypes.string,
  //path to background image
  theme: PropTypes.string
};
export default StoryMainPanelIntro;